<template>
  <embedded
    :iframeSrc="iframeSrc"
  />
</template>

<script>
import Embedded from '../custom-components/Embedded.vue'
import AppConstants from '../../constants/app.constants'

export default {
  components: {
    Embedded
  },
  data() {
    return {
      iframeSrc: AppConstants.HUB_USER_MGMT_EMBEDDED_URL
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/hub-user/UserManagement.vue